import React, { useState, useEffect } from 'react';
import { UserPlus, UserMinus, Loader2 } from 'lucide-react';
import { followService } from '../../services/followService';

export const FollowButton = ({ 
  chefId, 
  currentUserId, 
  initialIsFollowing = false,
  onFollowChange,
  size = 'default' // 'small' | 'default' | 'large'
}) => {
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [isLoading, setIsLoading] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    if (currentUserId && chefId && currentUserId !== chefId && !hasChecked) {
      checkFollowStatus();
    }
  }, [currentUserId, chefId, hasChecked]);

  const checkFollowStatus = async () => {
    try {
      const following = await followService.checkFollowStatus(currentUserId, chefId);
      setIsFollowing(following);
      setHasChecked(true);
    } catch (e) {
      console.error('Error checking follow status:', e);
    }
  };

  const handleFollow = async (e) => {
    e.stopPropagation();
    if (!currentUserId || currentUserId === chefId) return;
    
    setIsLoading(true);
    try {
      if (isFollowing) {
        await followService.unfollowUser(currentUserId, chefId);
        setIsFollowing(false);
        if (onFollowChange) onFollowChange(false);
      } else {
        await followService.followUser(currentUserId, chefId);
        setIsFollowing(true);
        if (onFollowChange) onFollowChange(true);
      }
    } catch (e) {
      console.error('Error toggling follow:', e);
      // Mostrar error al usuario
      alert(e.message || 'Error al procesar la acción');
    } finally {
      setIsLoading(false);
    }
  };

  // Don't show for own profile or if not logged in
  if (!currentUserId || currentUserId === chefId) {
    return null;
  }

  const sizeClasses = {
    small: 'px-4 py-2 text-[9px]',
    default: 'px-6 py-3 text-[10px]',
    large: 'px-8 py-4 text-[10px]'
  };

  const iconSize = size === 'small' ? 12 : size === 'large' ? 18 : 14;

  return (
    <button
      data-testid="follow-chef-btn"
      onClick={handleFollow}
      disabled={isLoading}
      className={`rounded-xl font-black uppercase tracking-widest transition-all flex items-center gap-2 ${sizeClasses[size]} ${
        isFollowing
          ? 'bg-stone-100 dark:bg-stone-800 text-stone-600 dark:text-stone-300 hover:bg-rose-50 hover:text-rose-500 dark:hover:bg-rose-900/20'
          : 'bg-primary text-white shadow-lg shadow-primary/20 hover:bg-primary/90'
      }`}
    >
      {isLoading ? (
        <Loader2 size={iconSize} className="animate-spin" />
      ) : isFollowing ? (
        <><UserMinus size={iconSize} /> <span className="hidden sm:inline">Siguiendo</span></>
      ) : (
        <><UserPlus size={iconSize} /> <span className="hidden sm:inline">Seguir</span></>
      )}
    </button>
  );
};

export default FollowButton;
